import { render, staticRenderFns } from "./Fines.vue?vue&type=template&id=5a83b6f2"
import script from "./Fines.vue?vue&type=script&lang=js"
export * from "./Fines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports